export const theme = {
  colors: {
    background: '#FFF8E5',
    primary: '#415378',
    white: '#FFFFFF',
    text: '#415378',
    buttonPrimary: '#415378',
    buttonSecondary: '#FFF8E5',
  },
  fonts: {
    header: '"DM Serif Display", serif',
    body: '"Afacad", sans-serif',
  },
  fontSizes: {
    h1: '48px',
    tagline: '24px',
    body: '18px',
    button: '16px',
    formLabel: '14px',
  },
  breakpoints: {
    mobile: '768px',
    tablet: '1024px',
  },
};